import { axios } from 'src/app/Axios';

export const updateHiddenPages = async (params: any) => axios.patch(params.apiDetails.endPoint, params.hiddenPages);
